import React, { Component } from 'react'

import { url_rest, greating } from 'configuration'
import { getRequest, postRequest } from 'services/ApiService.js'

export default class ResourceHeader extends Component {

  constructor(props) {
    super(props);

    var data = {
      "item_number": 0,
      "page_size": 20,
      "filters": {
        "slug": this.props.queryTerm
      }
    };

    postRequest(url_rest + "/resource/paginated", data, this.props.lang).then(
      (response) => {
        getRequest(url_rest + "/resource/get/" + response.data.list[0].id, this.props.lang).then(
          (response) => this.setState({ result: response.data }))
      });

    
  }

  render() {
    if (this.state != null) {
      var description = this.state.result.description
      if (description.length > 750) {
        var description_split = description.split('.')
        var newLength = description_split[0].length
        var i = 0
        var description = ''
        while (newLength < 750) {
          description += description_split[i] + '.'
          i++
          newLength += description_split[i].length
        }
      }
      return (
        <React.Fragment>
          <div className="hero-img">
            <h1>{greating[this.props.lang]}&nbsp;{this.state.result.name}</h1>
            <h2 className="desktop">{description}</h2>
            <img src={this.state.result.image}></img>
          </div>
          <h2 className="mobile">{description}</h2>
        </React.Fragment>
      )
    }
    else {
      return ("")
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ResourceHeader.jsx